import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 25 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#616A75",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.5 18.234V20.9h18.667v-2.666M8.833 8.5l4-4 4 4m-4 9.247V5.3"
    }, null, -1)
  ])))
}
export default { render: render }